var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("free-blocks")))]),
              _vm.blocks.length == 0
                ? _c("w-card-content", { staticClass: "no-blocks-content" }, [
                    _c("div", [
                      _vm._v(_vm._s(_vm.$ct("this-layout-has-no-free-blocks"))),
                    ]),
                  ])
                : _vm._e(),
              _c(
                "w-list",
                [
                  _vm._l(_vm.blocks, function (block, i) {
                    return _c(
                      "w-list-item",
                      { key: block.uid },
                      [
                        _c("w-list-item-text", [
                          _vm._v(_vm._s(block.getName(i))),
                        ]),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("tooltip.edit-block"),
                                    expression: "$ct('tooltip.edit-block')",
                                  },
                                ],
                                on: {
                                  click: function ($event) {
                                    return _vm.editBlock(block)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "pen" } })],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "w-list-item-action",
                          [
                            _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("tooltip.delete-block"),
                                    expression: "$ct('tooltip.delete-block')",
                                  },
                                ],
                                staticClass: "danger",
                                on: {
                                  click: function ($event) {
                                    return _vm.removeBlock(i)
                                  },
                                },
                              },
                              [_c("w-fa", { attrs: { icon: "trash" } })],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  }),
                  _c(
                    "w-list-item",
                    {
                      on: {
                        click: function ($event) {
                          return _vm.addFreeBlock()
                        },
                      },
                    },
                    [
                      _c("w-list-item-text", [
                        _c(
                          "div",
                          [
                            _c("w-fa", { attrs: { icon: "plus" } }),
                            _vm._v(
                              " " + _vm._s(_vm.$ct("create-new-free-block"))
                            ),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c(
            "transition",
            { attrs: { name: "fast-fade", mode: "out-in" } },
            [
              _vm.toEditBlock
                ? _c("app-free-block-edit", {
                    key: _vm.toEditBlock.uid,
                    attrs: { layout: _vm.layout, index: _vm.toEditBlockIndex },
                    model: {
                      value: _vm.toEditBlock,
                      callback: function ($$v) {
                        _vm.toEditBlock = $$v
                      },
                      expression: "toEditBlock",
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }